import user from './slices/user'
import gateways from './slices/gateways';
import device from './slices/device';
import mqtt from './slices/mqtt';
import licences from './slices/licences';
import ota from './slices/ota';

const rootReducer = {
  user,
  gateways,
  device,
  mqtt,
  licences,
  ota
};

export default rootReducer;